import { App as CapacitorApp } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { focusManager } from '@tanstack/react-query';

/**
 * Treats the native app returning to the foreground as a window focus, so stale queries refetch.
 * WKWebView does not reliably fire `visibilitychange` on resume, which is what React Query listens
 * for by default.
 */
export function installResumeRefetch(): void {
	if (!Capacitor.isNativePlatform()) return;

	focusManager.setEventListener(handleFocus => {
		const listener = CapacitorApp.addListener('appStateChange', ({ isActive }) => handleFocus(isActive));
		return () => {
			void listener.then(l => l.remove());
		};
	});
}
